"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProviderSelect = void 0;
var react_1 = __importStar(require("react"));
var react_device_detect_1 = require("react-device-detect");
var use_theme_1 = __importDefault(require("../hooks/use-theme"));
var tailwind_1 = __importDefault(require("../utils/tailwind"));
var styles = (0, tailwind_1.default)({
  button: "\n    tw-flex\n    tw-flex-row\n    tw-items-center\n    tw-text-left\n    tw-py-1.5\n    tw-pl-2\n    tw-pr-2\n    ".concat(react_device_detect_1.isMobile ? 'tw-w-full' : 'tw-w-11/12', "\n    tw-transition\n    tw-rounded-md\n    focus:tw-outline-none\n    tw-will-change-transform\n    tw-scale-100\n    active:tw-scale-95"),
  rowContainer: "\n    tw-flex \n    tw-flex-shrink-0 \n    tw-mr-4 \n    md:tw-mr-5",
  iconContainer: "\n    tw-my-auto \n    tw-rounded\n    tw-p-0.5\n    ".concat(react_device_detect_1.isMobile ? 'tw-h-10 tw-w-10' : 'tw-h-7 tw-w-7'),
  icon: "\n    tw-h-full \n    tw-w-full",
  name: "\n    tw-font-medium \n    tw-text-sm\n    tw-antialiased",
  description: "\n    tw-text-sm"
});
var ProviderSelect = function ProviderSelect(_ref) {
  var provider = _ref.provider,
    selected = _ref.selected,
    onClick = _ref.onClick;
  var theme = (0, use_theme_1.default)();
  var _ref2 = (0, react_1.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    hover = _ref3[0],
    setHover = _ref3[1];
  return react_1.default.createElement("button", {
    className: styles.button,
    style: {
      background: selected ? theme.primary : hover ? theme.muted : '',
      color: selected ? theme.secondary : theme.text
    },
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    onClick: onClick
  }, react_1.default.createElement("div", {
    className: styles.rowContainer
  }, react_1.default.createElement("span", {
    className: styles.iconContainer,
    style: {
      background: theme.muted
    }
  }, typeof provider.icon === 'string' ? react_1.default.createElement("img", {
    src: provider.icon,
    alt: "".concat(provider.name, " logo"),
    className: styles.icon
  }) : react_1.default.createElement(provider.icon, {
    className: styles.icon
  }))), react_1.default.createElement("div", null, react_1.default.createElement("div", {
    className: styles.name,
    style: {
      color: selected ? theme.secondary : theme.text
    }
  }, provider.name), react_device_detect_1.isMobile && react_1.default.createElement("div", {
    className: styles.description,
    style: {
      color: theme.textSecondary
    }
  }, provider.description)));
};
exports.ProviderSelect = ProviderSelect;